import {Modal} from 'bootstrap';
import htmx from 'htmx.org';

document.addEventListener("DOMContentLoaded", function() {
    const confirmModal = document.getElementById('confirmModal');
    if (confirmModal) {
        const bsConfirmModal = new Modal(confirmModal);
        const confirmBtn = document.getElementById('confirmModalConfirmBtn');
        const modalBody = document.getElementById('confirmModalBody');

        htmx.on("htmx:confirm", function(evt) {
            // Check if it's a custom confirm
            if (evt.detail.question) {
                evt.preventDefault();
                modalBody.innerText = evt.detail.question;

                const handleConfirm = function() {
                    evt.detail.issueRequest(true);
                    bsConfirmModal.hide();
                    confirmBtn.removeEventListener('click', handleConfirm);
                };

                confirmBtn.addEventListener('click', handleConfirm);

                confirmModal.addEventListener('hidden.bs.modal', function() {
                    confirmBtn.removeEventListener('click', handleConfirm);
                }, { once: true });

                bsConfirmModal.show();
            }
        });
    }
});

